<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.metadata}}</h3>
    <h5 class="modal-subtitle">
		<span [innerHTML]="recordTitle | safeHtml"></span>
	</h5>
</div>
<!-- // Standard view -->
<div *ngIf="view == 'standard'" class="modal-body">
	<div style="max-height:400px;overflow-y:auto;overflow-x:hidden">
		<div class="list-group-item product-views" *ngIf="views">
			<span>{{ views.total | i18nPlural: pluralMapping }} since {{ views.loadDateDisplay }}</span>
		</div>
		<div *ngFor='let field of Object.values(record)' class="list-group-item">
			<h4 class="list-group-item-heading">{{field.label}}</h4>
			<div *ngIf="field.links" >
                <ul class="link-list">
                <div *ngIf="field.name == 'browsepath'" > 
	                <ul class="link-list">
	                    <li *ngFor="let link of field.links">
	                        <a class="pointMe" (click)="handleBrowsepathLink(link.href)"> 
	                            {{link.name.replace('////','//')}} 
	                        </a>
	                    </li>
	                </ul>
	            </div>
	            <div *ngIf="field.name != 'browsepath'" >
                    <li *ngFor="let link of field.links">
                        <a *ngIf="link.href.indexOf('file://')!=10" 
                            href="{{link.href.replace('////','//')}}" 
                            target="_blank" 
                            (click)="displayLinkMsg(link.href)"> 
                            {{link.name.replace('////','//')}} 
                        </a>
                    </li>
                </div>
                </ul>				 
			</div>
            <div *ngIf="!field.links && searchableMetadataFields.includes(field.name)">
				<a *ngIf="field.isValidCollection" 
				   class="pointMe" 
				   (click)="resultFieldSearch(field.name, field.cleanedValue)" 
				   [title]="field.cleanedValue">
				  {{ field.cleanedValue }}
				</a> 
                <p *ngIf="!field.isValidCollection"
                    class='dd-text-collapse'
                    ddTextCollapse
                    [ddTextCollapseMaxLength]="field.maxLength" 
                    [ddTextCollapseText]="field.cleanedValue">
                </p>
            </div>                                  
            <p *ngIf="!field.links && !searchableMetadataFields.includes(field.name)"
               class='dd-text-collapse'
               ddTextCollapse
               [ddTextCollapseMaxLength]="field.maxLength" 
               [ddTextCollapseText]="field.value">
            </p>			
		</div>
	</div>
</div>
<!-- // END Standard view -->
<!-- // Template view -->
<div *ngIf="view == 'template'" class="modal-body metadata-form-data-container">
	<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs nav-justified">
	    <li *ngFor="let tab of dataform.tabs; let i = index" [ngbNavItem]="i" class="nav-item" [hidden]="!tab.canaccess">
	        <a ngbNavLink class="nav-link">{{ tab.label }}</a>
	        <ng-template ngbNavContent>
			    <dl class="dl-horizontal form-data-tab-field">
			        <span class="tab-row" *ngFor="let field of tab.fields">
			            <dt class="form-data-tab-field-header">{{ field.label }}</dt>
			            <dd class="form-data-tab-field-value" [ngClass]="{'form-data-tab-field-datalink': field.datalink}">        
							<div *ngIf="field.links">
				                <ul class="link-list">
				                    <li *ngFor="let link of field.links">
				                        <a *ngIf="link.href.indexOf('file://')!=10" 
				                            href="{{link.href.replace('////','//')}}" 
				                            target="_blank" 
				                            (click)="displayLinkMsg(link.href)"> 
				                            {{link.name.replace('////','//')}} 
				                        </a>
				                    </li>
				                </ul>							
							</div>
				            <div *ngIf="!field.links && searchableMetadataFields.includes(field.name)">
								<a *ngIf="field.isValidCollection" 
								   class="pointMe" 
								   (click)="resultFieldSearch(field.name, field.cleanedValue)" 
								   [title]="field.cleanedValue">
								  {{ field.cleanedValue }}
								</a> 
				                <p *ngIf="!field.isValidCollection"
				                    class='dd-text-collapse'
				                    ddTextCollapse
				                    [ddTextCollapseMaxLength]="field.maxLength" 
				                    [ddTextCollapseText]="field.cleanedValue">
				                </p>
				            </div>                                  
				            <span *ngIf="!field.links && !searchableMetadataFields.includes(field.name)"
				               class='dd-text-collapse'
				               ddTextCollapse
				               [ddTextCollapseMaxLength]="field.maxLength" 
				               [ddTextCollapseText]="field.value">
				            </span>                    
			            </dd> 
			        </span>
			    </dl>	                        
	        </ng-template>	        
	    </li>
	</ul>
	<div [ngbNavOutlet]="nav" class="tab-content"></div>	
	
	<div *ngIf="dataform.iserror"><i>{{LOCALIZATION.resultsEmpty}}</i></div>
</div>
<!-- // END Template view -->
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
	<button class="btn btn-default" type="button" (click)="print()" [hidden]="view == 'template'">{{LOCALIZATION.print}}</button>
</div>
